// extracted by mini-css-extract-plugin
module.exports = {"container":"Record_container__1vYAG","Holder":"Record_Holder__3MwOv"};